// Created on 2021-04-19
// Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential
// Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-19
const htmlFrameworkInit = {
  init: function (properties) {
    // feather icons
    properties.$feather = () => {
      setTimeout(() => {
        window.feather.replace();
      })
    }

    // success modal
    properties.$openSuccessModal = () => {
      document.getElementById('menu-success').classList.add('menu-active');
      document.getElementsByClassName('menu-hider')[0].classList.add('menu-active');    
    }

    // error modal
    properties.$openErrorModal = () => {
      document.getElementById('menu-error').classList.add('menu-active');
      document.getElementsByClassName('menu-hider')[0].classList.add('menu-active');    
    }

    // warning modal
    properties.$openWarningModal = () => {
      document.getElementById('menu-warning').classList.add('menu-active');
      document.getElementsByClassName('menu-hider')[0].classList.add('menu-active');    
    }

    // confirm modal
    properties.$openConfirmModal = () => {
      document.getElementById('menu-confirm').classList.add('menu-active');
      document.getElementsByClassName('menu-hider')[0].classList.add('menu-active');    
    }

    // pin modal
    properties.$openPinModal = () => {
      document.getElementById('modal-pin').classList.add('menu-active');
      document.getElementsByClassName('menu-hider')[0].classList.add('menu-active');    
    }

    // sync modal
    properties.$openSyncModal = () => {
      document.getElementById('modal-sync').classList.add('menu-active');
      document.getElementsByClassName('menu-hider-dis')[0].classList.add('menu-active');    
    }

    properties.$hideSyncModal = () => {
      document.getElementById('modal-sync').classList.remove('menu-active');
      document.getElementsByClassName('menu-hider-dis')[0].classList.remove('menu-active');    
    }
  }
}

export default htmlFrameworkInit